<script>
export default {
    name: "Freesub"
}
</script>

<template>
    <div class="action-free-sub">
        <div class="action-container">
            <div class="action-title">Бесплатная подписка</div>
            <div class="action-sub">Каждый, кто авторизуется в нашем приложении через Discord до 30.03.2025, в подарок получает подписку Cloud Premium сроком на 1 неделю!</div>
        </div>
    </div>
</template>

<style scoped>
.action-free-sub {
    position: absolute;

    width: 10%;
    height: 24vh;

    margin-top: 30%;
    right: 5%;

    background: #090909;
    border-radius: 1vh;
    border: 1px solid rgba(255, 255, 255, 0.12);

    display: flex;
    align-items: center;
    justify-content: center;
}

.action-container {
    display: flex;
    align-items: center;
    flex-direction: column;

    gap: 1vh;
}

.action-title {
    font-size: 14px;
}

.action-sub {
    text-align: center;
    width: 70%;
    font-size: 12px;
    opacity: 0.6;
}
</style>